import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { cmsVersions, restoreCms } from "@/services/cmsApi";
import { fmtTs } from "@/lib/format";
import { CmsPublishGate } from "./CmsPublishGate";

export function VersionsSheet({ target, docId, open, onClose }) {
  const [list, setList] = useState(null);
  const [gate, setGate] = useState(null);
  const load = () => cmsVersions(target, docId).then(setList).catch((e) => { toast.error(e?.response?.data?.detail || e.message); setList([]); });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (open) { setList(null); load(); } }, [open, target, docId]);
  const restore = (v) => setGate({
    title: `Restore version from ${fmtTs(v.published_at)}`, description: "Overwrites the live content. Requires the profile password and an OTP sent to",
    run: async (auth) => { await restoreCms({ ...auth, version_id: v.id }); toast.success("Version restored & live"); load(); },
  });
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="w-full sm:max-w-lg overflow-y-auto" data-testid="cms-versions-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-heading">Published versions</SheetTitle>
          <SheetDescription className="font-mono">{target}/{docId}</SheetDescription>
        </SheetHeader>
        <div className="mt-4 space-y-2">
          {list === null && <p className="text-xs text-muted-foreground">Loading…</p>}
          {list?.length === 0 && <p className="text-xs text-muted-foreground py-6 text-center" data-testid="cms-versions-empty">No versions yet — the first Publish creates one.</p>}
          {list?.map((v, i) => (
            <div key={v.id} className="rounded-lg border border-border p-3 flex items-start justify-between gap-2" data-testid={`cms-version-${v.id}`}>
              <div className="min-w-0">
                <p className="text-sm text-foreground">{fmtTs(v.published_at)} {i === 0 && <span className="text-[10px] rounded-full bg-emerald-100 text-emerald-800 px-1.5 py-0.5 ml-1">live</span>}</p>
                <p className="text-[11px] text-muted-foreground">{v.published_by}{v.restored_from ? ` · restore of ${v.restored_from.slice(0, 6)}` : ""}</p>
                {v.note && <p className="text-xs mt-1">{v.note}</p>}
              </div>
              {i > 0 && <Button size="sm" variant="outline" className="h-7 gap-1 shrink-0" onClick={() => restore(v)} data-testid={`cms-restore-${v.id}`}><Icons.RotateCcw className="h-3.5 w-3.5" /> Restore</Button>}
            </div>
          ))}
        </div>
        <CmsPublishGate gate={gate} onClose={() => setGate(null)} />
      </SheetContent>
    </Sheet>
  );
}
